import Vue from 'vue'
import Vuex from 'vuex'

import todos from './todos'
import todoList from './todoList'
import auth from './auth/Login'
import register from './auth/Register'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    todos,
    todoList,
    auth,
    register,
  }
})
